import { DEV_MODE } from "../constants";

/**
 *
 *  Base64 encode / decode
 *  http://www.webtoolkit.info/
 *
 **/
const Base64 = {
  // private property
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

  // public method for encoding
  encode: function (input: String) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    input = Base64._utf8_encode(input);

    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output =
        output +
        this._keyStr.charAt(enc1) +
        this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) +
        this._keyStr.charAt(enc4);
    }

    return output;
  },

  // public method for decoding
  decode: function (input: String) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }

    output = Base64._utf8_decode(output);

    return output;
  },

  // private method for UTF-8 encoding
  _utf8_encode: function (string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }

    return utftext;
  },

  // private method for UTF-8 decoding
  _utf8_decode: function (utftext) {
    var c1, c2, c3;
    var string = "";
    var i = 0;
    var c = (c1 = c2 = 0);

    while (i < utftext.length) {
      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        i += 3;
      }
    }

    return string;
  },
};

class PlayerCompletion {
  public levelsCompleted: Set<string>;
  _lastLevelEntered: string | undefined;

  set lastLevelEntered(key: string | undefined) {
    this._lastLevelEntered = key;
    this.justWonLevel = undefined;
  }
  get lastLevelEntered(): string | undefined {
    return this._lastLevelEntered;
  }
  justWonLevel: string | undefined;
  constructor() {
    if (DEV_MODE) {
      return;
    }
    this.levelsCompleted = new Set();
    const params = new URLSearchParams(window.location.search);
    let save = undefined;
    try {
      if (params.has("pSave")) {
        save = JSON.parse(Base64.decode(params.get("pSave") || ""));
      }
    } catch (e) {
      console.log(e);
      save = undefined;
    }
    if (Array.isArray(save)) {
      // save = [
      //   "0.4_toggle_door_take2",
      //   "0.5_enemy_button",
      //   "0.2_blockage",
      //   "1.1_corridor",
      //   "Nic21",
      //   "4.0_reflection",
      //   "1.3_three_rooms",
      //   "4.1_far_dmg_switch",
      //   "2.4_herder_lite",
      //   "1.4_3doors2crates",
      // ];
      this.levelsCompleted = new Set(save);
      // console.log(save);
    } else {
      const state = localStorage.getItem("playerState");
      if (state !== null) {
        const levelsFromState = JSON.parse(state);
        this.levelsCompleted = new Set(levelsFromState);
      } else {
        this.levelsCompleted = new Set([]);
      }
    }

    // history.replaceState(
    //   {},
    //   "",
    //   location.origin +
    //     `?pSave=${Base64.encode(
    //       JSON.stringify(Array.from(this.levelsCompleted))
    //     )}`
    // );
  }

  unlockLevel(levelKey: string) {
    if (DEV_MODE) {
      return;
    }
    if (!this.levelsCompleted.has(levelKey)) {
      this.justWonLevel = levelKey;
    } else {
      this.justWonLevel = undefined;
    }

    this.levelsCompleted.add(levelKey);
    this.saveState();
  }

  saveState() {
    if (DEV_MODE) {
      return;
    }

    localStorage.setItem(
      "playerState",
      JSON.stringify(Array.from(this.levelsCompleted))
    );
    // history.replaceState(
    //   {},
    //   "",
    //   location.origin +
    //     `?pSave=${Base64.encode(
    //       JSON.stringify(Array.from(this.levelsCompleted))
    //     )}`
    // );
  }
}

const playerState = new PlayerCompletion();

export const PlayerState = playerState;
